import { css } from '@emotion/core';

export const searchBoxCustomerIconCSS = ({ colors, fontSizes }) => css`
    font-size: ${fontSizes.medium};
    color: ${colors.blueLight};
`;

export const searchBoxClientIconCSS = ({ colors }) => css`
    color: ${colors.neutral30};
`;

export const searchBoxFamilyIconCSS = ({ colors, fontSizes }) => css`
    font-size: ${fontSizes.medium};
    color: ${colors.orange};
`;
